import { Stack, useTheme } from "@mui/material";
import React, { forwardRef, useRef } from "react";
import { NcentralStep1 } from "./NcentralStep1";
import { NcentralStep2 } from "./NcentralStep2";
import { NcentralStep3 } from "./NcentralStep3";

export const NcentralMainWrapper = forwardRef(
  (
    {
      step,
      onStepChange,
    }: { step: number; onStepChange: (step: number) => void },
    ref,
  ) => {
    const theme = useTheme();

    switch (step) {
      case 1:
        return <NcentralStep1 ref={ref} onStepChange={onStepChange} />;
      case 2:
        return <NcentralStep2 ref={ref} onStepChange={onStepChange} />;
      case 3:
        return <NcentralStep3 ref={ref} onStepChange={onStepChange} />;
      default:
        return <NcentralStep1 onStepChange={onStepChange} />;
    }
  },
);
